import api from '../../api'

const SET_PROJECT_SELECTED = 'PROJECT_SET_SELECTED'

const initialState = {
	selected: -1,
}

const actions = {
	set_selected: function ({commit, dispatch, rootState}, value) {
		commit(SET_PROJECT_SELECTED, value)
	},
}

const mutations = {

	[SET_PROJECT_SELECTED](state, value) {
		state.selected = parseInt(value)
	}
}

const getters = {
	selected: function (state) {
		return state.selected
	}
}

export default {
	namespaced: true,

	state: initialState,

	actions,
	mutations,
	getters,
}